// Greenleaze variables

window.init = false;
window.initPrice = false;
window.monthValues = [12, 18, 24, 36];
var rawrules = {};
var formated = {};
window.priceRules = [];
let isCart = false;
let tva = 1.2;
let trackingId = null;

const greenleazePriceActualize = new Event("greenleazePriceActualize");

// ----------------------
// Helpers
// ----------------------
function parseRule(rule, values) {
  return new Function(
    "return " + ("" + rule).replace(/\[\[(\w+)\]\]/g, (_, key) => values[key]),
  );
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

// --- NEW: helpers pour récupérer les IDs de clic Google (gclid / wbraid / gbraid)
function getQueryParam(name) {
  try {
    const v = new URLSearchParams(location.search).get(name);
    return v ? decodeURIComponent(v) : "";
  } catch (e) {
    return "";
  }
}

// _gcl_aw a souvent le format "1.<ts>.<GCLID>"
function parseGclAw(raw) {
  if (!raw) return "";
  const parts = String(raw).split(".");
  return parts.length >= 3 ? parts[2] : raw;
}

function getGclidFromCookie() {
  // priorité à l’URL (si l’utilisateur vient d’un clic Ads)
  const fromUrl = getQueryParam("gclid");
  if (fromUrl) return fromUrl;

  // puis cookie Conversion Linker
  const gcl_aw = getCookie("_gcl_aw");
  if (gcl_aw) return parseGclAw(gcl_aw);

  // certains setups posent _gclid
  const gclidCookie = getCookie("_gclid");
  return gclidCookie || "";
}

function getWbraid() {
  return getQueryParam("wbraid") || getCookie("_wbraid") || "";
}

function getGbraid() {
  return getQueryParam("gbraid") || getCookie("_gbraid") || "";
}

// ----------------------
// Pricing helpers
// ----------------------
window.getAllPricesForProduct = function getAllPricesForProduct(
  productPriceHT,
) {
  const result = {};
  for (month in window.monthValues) {
    result[window.monthValues[month]] = getRuleByProductPriceAndDuration(
      productPriceHT,
      window.monthValues[month],
    );
  }
  return result;
};

window.getRuleByProductPriceAndDuration =
  function getRuleByProductPriceAndDuration(productPriceHT, duration = 36) {
    if (!window.monthValues.includes(duration))
      duration = window.monthValues[window.monthValues.length - 1];
    productPriceFormat = parseFloat(productPriceHT);
    const rule = window.priceRules.find(
      (priceRule) =>
        priceRule.duration == duration &&
        priceRule.minPrice <= productPriceFormat &&
        priceRule.maxPrice >= productPriceFormat,
    );
    if (!rule) {
      console.error("No price rule found", window.priceRules);
      getAllPriceRules();
      return null;
    }
    const monthlyRule = parseRule("" + rule.rule, {
      tva,
      prixHT: productPriceHT,
    });
    const depositRule = parseRule("" + rule.depositRule, {
      tva,
      prixHT: productPriceHT,
    });
    return rule
      ? {
          monthly: monthlyRule(),
          initial: depositRule(),
        }
      : { monthly: "0.00", initial: "0.00" };
  };

async function getAllPriceRules() {
  const rulesFetch = await fetch("/apps/greenleaze-proxy/pricing", {
    method: "GET",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
  rawrules = await rulesFetch.json();
  window.priceRules = rawrules;
  const uniqueDurations = new Set();
  for (let index = 0; index < window.priceRules.length; index++) {
    uniqueDurations.add(window.priceRules[index].duration);
  }
  window.monthValues = [...uniqueDurations].sort(function (a, b) {
    return a - b;
  });
  window.initPrice = true;
  console.log("GREENLEAZE INITIALIZED - Dispatching event");

  // S'assurer que l'événement est dispatché après un court délai
  setTimeout(() => {
    window.dispatchEvent(greenleazePriceActualize);
    console.log("GREENLEAZE EVENT DISPATCHED");
  }, 100);
}

// ----------------------
// Redirect + tracking
// ----------------------
async function sendCartAndRedirect(duration, variantId, pdistinctId) {
  console.log("sendCartAndRedirect", duration, variantId, pdistinctId);

  // Flag pour empêcher l'ouverture du drawer cart lors d'un ajout Greenleaze
  window.greenleazeAddToCart = true;

  // Bloquer temporairement les événements cart-drawer:open
  const blockDrawerOpen = (e) => {
    e.stopImmediatePropagation();
    e.preventDefault();
  };

  document.addEventListener("cart-drawer:open", blockDrawerOpen, true);

  let cartContentsRes = await fetch(window.Shopify.routes.root + "cart.js");
  let cartContents = await cartContentsRes.json();

  if (variantId) {
    const hasVariantId = cartContents.items.some(
      (item) => item.variant_id == variantId,
    );

    if (!hasVariantId) {
      // Utiliser l'API Shopify Cart pour ajouter au panier
      await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });
      cartContentsRes = await fetch(window.Shopify.routes.root + "cart.js");
      cartContents = await cartContentsRes.json();
    }
  }

  // Réinitialiser le flag après un délai plus long
  setTimeout(() => {
    window.greenleazeAddToCart = false;
    document.removeEventListener("cart-drawer:open", blockDrawerOpen, true);
  }, 1000);

  if (!trackingId)
    trackingId =
      window.ShopifyAnalytics?.lib?.user()?.traits()?.uniqToken ||
      self?.crypto?.randomUUID();

  // NEW: récupérer les IDs de clic (gclid/wbraid/gbraid)
  const gclid = getGclidFromCookie();
  const wbraid = getWbraid();
  const gbraid = getGbraid();

  let ack = await fetch("/apps/greenleaze-proxy/send-card", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify({
      cartContents: JSON.stringify(cartContents),
      duration: duration,
      trackingId: trackingId,
      trackingData: {
        _shopify_y: getCookie("_shopify_y"),
        _ga: getCookie("_ga"),
        _gcl_au: getCookie("_gcl_au"),
        _gac_: getCookie("_gac_"),
        _gcl: getCookie("_gcl"),
        _fbp: getCookie("_fbp"),
        _fbc: getCookie("_fbc"),

        // --- NEW: on envoie les IDs de clic à Greenleaze pour qu'ils les relaient dans order_confirmed
        gclid: gclid,
        wbraid: wbraid,
        gbraid: gbraid,
      },
      postHogtrackingId: pdistinctId || trackingId,
    }),
  });

  if (ack.ok) {
    ack = await ack.json();
    if (ack?.message) {
      console.error(ack?.message);
    }
    if (ack?.redirectUrl) {
      // NEW: ceinture et bretelles — on ajoute aussi les IDs à l’URL de redirection
      let redirectUrl =
        ack?.redirectUrl +
        "&duration=" +
        duration +
        "&rand=" +
        new Date().getTime();

      if (gclid) redirectUrl += "&gclid=" + encodeURIComponent(gclid);
      if (wbraid) redirectUrl += "&wbraid=" + encodeURIComponent(wbraid);
      if (gbraid) redirectUrl += "&gbraid=" + encodeURIComponent(gbraid);

      console.log("redirecting to ", redirectUrl);

      window.location.href = redirectUrl;
      document.location.href = redirectUrl;
      location.href = redirectUrl;
      return;
    }
  } else {
    console.error("Une erreur s'est produite.");
    console.error("error during saved ", ack);
  }
  return;
}

// ----------------------
// Init & UI helpers
// ----------------------
async function initGreenleaze() {
  console.log("INITIALIAZING GREENLEAZE");
  await getAllPriceRules();
  window.init = true;
}
if (!window.init) {
  initGreenleaze();
} else {
  console.log("GREENLEAZE ALREADY INITIALIZED");
}

// Fonction globale pour forcer la réinitialisation
window.forceReinitGreenleaze = function () {
  console.log("FORCING GREENLEAZE REINITIALIZATION");
  if (window.initPrice && window.init) {
    setTimeout(() => {
      window.dispatchEvent(new Event("greenleazePriceActualize"));
      console.log("GREENLEAZE REINITIALIZATION EVENT DISPATCHED");
    }, 100);
  } else {
    console.warn("GREENLEAZE NOT READY FOR REINITIALIZATION");
  }
};

function setGreenleazePrice(container, productId, price) {
  if (!window.initPrice) {
    return;
  }

  const prixHT = (price / 100) * (5 / 6);
  const id = productId;
  if (!container) {
    return;
  }

  const tva = 120 / 100;
  const rules = getRuleByProductPriceAndDuration(prixHT);
  if (!rules) return;

  const calculatePayment = parseRule(rules.monthly, { tva, prixHT });
  const paiementMensuel = calculatePayment();
  container.innerHTML = `À partir de ${paiementMensuel} € / mois`;
}
window.setGreenleazePrice = setGreenleazePrice;

window.addEventListener("greenleazePriceActualize", () => {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const element of mutation.target.querySelectorAll(
        '[data-greenleaze-element="price"]',
      )) {
        setGreenleazePrice(
          element,
          element.dataset.productId,
          parseInt(element.dataset.price, 10),
        );
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  for (const element of document.querySelectorAll(
    '[data-greenleaze-element="price"]',
  )) {
    setGreenleazePrice(
      element,
      element.dataset.productId,
      parseInt(element.dataset.price, 10),
    );
  }
});
